<template>
  <div>
    <v-divider class="yellow"></v-divider>
    <v-layout row wrap>
      <v-flex xs12 md5>
        <v-card flat class="ma-0 pa-0 text-xs-center" height="400" min-width="100">
          <v-card-title class="pt-1">
            <p class="display-1 pl-3 pt-3 mt-1">Professional Artist and Illustrator</p>          
          </v-card-title>
          <p class="pa-3 ma-0 text-xs-justify">
              {{artnote}}
          </p>
          <v-img
              :src=mainimage
              max-width="100%"
              max-height="500">
         </v-img>
        </v-card>
      </v-flex>
      <v-flex wrap xs12 md7 class="flexcard">
        <v-carousel :show-arrows="false">
          <v-carousel-item v-for="(item,i) in items" :key="i" :src="item.src"></v-carousel-item>
        </v-carousel>
      </v-flex>
    </v-layout>
    <v-divider class="yellow"></v-divider>
    <v-layout row wrap>
      <v-flex xs12 md4 wrap>
        <v-divider class="blue pa-1"></v-divider>
        <v-card flat class="pa-3 blue lighten-5 lighten-4">
          <h3 class="pl-3 black--text">
            <v-icon color="green">brightness_high</v-icon>PENCIL ART
          </h3>
          <v-img
              :src=leftimage
              max-width="100%"
              max-height="500">
         </v-img>
        </v-card>
      </v-flex>
      <v-flex xs12 md4 wrap>
        <v-divider class="red pa-1"></v-divider>
        <v-card flat class="pa-3 blue lighten-5 lighten-4">
          <h3 class="pl-3 black--text">
            <v-icon color="green">monetization_on</v-icon>DIGITAL ART
          </h3>
         <v-img
              :src=midimage
              max-width="100%"
              max-height="500">
         </v-img>
        </v-card>
      </v-flex>
      <v-flex xs12 md4 wrap>
        <v-divider class="blue pa-1"></v-divider>
        <v-card flat class="pa-3 blue lighten-4">
          <h3 class="pl-3 black--text">
            <v-icon color="green">check_circle</v-icon>2D ART DESIGN
          </h3>
          <v-img
              :src=rightimage
              max-width="100%"
              max-height="500">
         </v-img>
        </v-card>
      </v-flex>
    </v-layout>
    <v-divider class="yellow"></v-divider>
    <v-layout row wrap>
      <v-flex xs12 md4 wrap>
        <v-divider class="blue pa-1"></v-divider>
        <v-card flat class="pa-3 blue lighten-5 lighten-4">
          <v-img
              :src=leftimage1
              max-width="100%"
              max-height="500">
         </v-img>
        </v-card>
      </v-flex>
      <v-flex xs12 md4 wrap>
        <v-divider class="red pa-1"></v-divider>
        <v-card flat class="pa-3 blue lighten-5 lighten-4">
         <v-img
              :src=midimage1
              max-width="100%"
              max-height="500">
         </v-img>
        </v-card>
      </v-flex>
      <v-flex xs12 md4 wrap>
        <v-divider class="blue pa-1"></v-divider>
        <v-card flat class="pa-3 blue lighten-4">
          <v-img
              :src=rightimage1
              max-width="100%"
              max-height="500">
         </v-img>
        </v-card>
      </v-flex>
    </v-layout>
     <v-divider class="yellow"></v-divider>
    <v-layout row wrap>
      <v-flex xs12 md4 wrap>
        <v-divider class="blue pa-1"></v-divider>
        <v-card flat class="pa-3 blue lighten-5 lighten-4">
          <v-img
              :src=leftimage2
              max-width="100%"
              max-height="500">
         </v-img>
        </v-card>
      </v-flex>
      <v-flex xs12 md4 wrap>
        <v-divider class="red pa-1"></v-divider>
        <v-card flat class="pa-3 blue lighten-5 lighten-4">
         <v-img
              :src=midimage2
              max-width="100%"
              max-height="500">
         </v-img>
        </v-card>
      </v-flex>
      <v-flex xs12 md4 wrap>
        <v-divider class="blue pa-1"></v-divider>
        <v-card flat class="pa-3 blue lighten-4">
          <v-img
              :src=rightimage2
              max-width="100%"
              max-height="500">
         </v-img>
        </v-card>
      </v-flex>
    </v-layout>
    <v-divider class="yellow"></v-divider>
    <v-layout row wrap>
      <v-flex xs12 md4 wrap>
        <v-divider class="blue pa-1"></v-divider>
        <v-card flat class="pa-3 blue lighten-5 lighten-4">
          <v-img
              :src=leftimage3
              max-width="100%"
              max-height="500">
         </v-img>
        </v-card>
      </v-flex>
      <v-flex xs12 md4 wrap>
        <v-divider class="red pa-1"></v-divider>
        <v-card flat class="pa-3 blue lighten-5 lighten-4">
         <v-img
              :src=midimage3
              max-width="100%"
              max-height="500">
         </v-img>
        </v-card>
      </v-flex>
      <v-flex xs12 md4 wrap>
        <v-divider class="blue pa-1"></v-divider>
        <v-card flat class="pa-3 blue lighten-4">
          <v-img
              :src=rightimage3
              max-width="100%"
              max-height="500">
         </v-img>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
  
</template>
<script>
import router from "../router.js";
import backgroundUrl from "../assets/10021.jpg";
import backgroundUrl2 from "../assets/10010.jpg";
import backgroundUrl3 from "../assets/10017.jpg";
export default {
  data() {
    return {
      leftimage: require("../assets/10002.jpg"),
      midimage: require("../assets/10010.jpg"),
      rightimage: require("../assets/10017.jpg"),
      leftimage1: require("../assets/10007.jpg"),
      midimage1: require("../assets/10008.jpg"),
      rightimage1: require("../assets/10018.jpg"),
      leftimage2: require("../assets/10017.jpg"),
      midimage2: require("../assets/10011.jpg"),
      rightimage2: require("../assets/10016.jpg"),
      leftimage3: require("../assets/10004.jpg"),
      midimage3: require("../assets/10019.jpg"),
      rightimage3: require("../assets/10020.jpg"),
      mainimage: require("../assets/10022.jpg"),
      items: [
        {
          src: require("../assets/10013.jpg")
        },
        {
          src: require("../assets/10014.jpg")
        },
        {
          src: require("../assets/10015.jpg")
        },
        {
          src: require("../assets/10016.jpg")
        },
        {
          src: require("../assets/10003.jpg")
        },
        {
          src: require("../assets/10005.jpg")
        },
        {
          src: require("../assets/10008.jpg")
        },
        {
          src: require("../assets/10012.jpg")
        }
      ],
      artnote: "I am a professional Artist and illustrater of quality art and graphics. Allow me to use my art skills to create something interesting, unique or functional for use as an advertisement or product packaging, for sale or exhibition, or just for entertainment.  Original artwork for books, product packaging, greeting cards, or anything else that requires images. As an illustrator, I can use traditional media such as acrylic or oil paints, pen and ink, or colored pencils and I can also use my skills set to include digital drawing programs to design your artwork.",
      discount:
        "Start a travel business with less than $50. When you become a sales representative, you get an opportunity to promote high selling and high profitable dreamtrips packages to boost your income. ",
      membership: "",
      booking:
        "Book your next getaway with dreamgiver to redeem your $100 from the dreamgiver card. When you use your $100 savings a portion of profits from your booking goes to help children in need.",
      travel:
        "Become a member to start saving for your travels in advance. We have Unlimited membership benefits and the cheapest travel packages!. Appropriately priced for different travel needs",
      note:
        "The most important things online are trust and accurate reviews. We have taken our time to investigate the best travel partners. They are many but we believe you only need one. THE BEST!",
      backgroundUrl,
      bookingUrl: "",
      value: 0,
      search: "",
      interval: {},
      btn: false,
      overlay: false,
      slide: {},
      status: 0,
      outdialog: false
    };
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    goBooking() {}
  },
  watch() {
    javascript: document.getElementsByClassName("video")[0].loop = true;
  },
  created() {
    this.value = 0;
  }
};
</script>
<style lang="stylus" scoped>
.v-progress-circular {
  margin: 1rem;
}

.flexcard {
  display: flex;
  flex-direction: column;
}

.flexcard .v-toolbar {
  flex: 0;
}
</style>